import script from "./labels.vue?vue&type=script&lang=js"
export * from "./labels.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__